module.exports = __webpack_public_path__ + "static/media/http_01_challenge.217bd908.png";